var map = {
	"./awards/cannes.png": 3338,
	"./awards/deutscherkamerapreis.png": 2301,
	"./awards/jupiter.png": 5187,
	"./awards/lafa.png": 356,
	"./awards/selb.png": 7856,
	"./awards/shokingshorts.png": 5912,
	"./berlin.svg": 7799,
	"./bielefeld.svg": 2259,
	"./bremerhaven.svg": 6080,
	"./de.svg": 8610,
	"./en.svg": 8986,
	"./leaves_left.svg": 65,
	"./leaves_right.svg": 3260,
	"./nrw.svg": 3666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;